import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

export default function CrmTeam() {
  const [members, setMembers] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const load = async () => {
    const { data } = await api.get("/crm/team");
    setMembers(data.members);
  };
  useEffect(() => { load().catch(() => setError("Could not load employee access.")); }, []);
  const act = async (fn) => {
    setBusy(true); setError(""); setLink("");
    try {
      const { data } = await fn();
      if (data.token) {
        const url = new URL(`${process.env.PUBLIC_URL || ""}/crm/activate`, window.location.origin);
        url.searchParams.set("token", data.token);
        setLink(url.href);
      }
      await load();
    } catch (e) { setError(formatApiError(e.response?.data?.detail) || "Could not update employee access."); }
    finally { setBusy(false); }
  };
  return <section className="border rounded-lg bg-white p-4 space-y-4">
    <h2 className="font-semibold text-[#17324D]">Employee CRM access</h2>
    <p className="text-sm text-stone-600">Employees can view and update all CRM records, but cannot access formulas, Bench tools, or manage employees. Create an invitation and send the private link yourself. Links expire after 48 hours; no email is sent automatically.</p>
    <form className="flex flex-wrap gap-2" onSubmit={e => { e.preventDefault(); act(() => api.post("/crm/team", { name, email })); }}>
      <input aria-label="Employee name" placeholder="Employee name" className="border rounded p-2 text-sm" required maxLength={160} value={name} onChange={e => setName(e.target.value)} />
      <input aria-label="Employee email" placeholder="Employee email" className="border rounded p-2 text-sm" required type="email" value={email} onChange={e => setEmail(e.target.value)} />
      <button className="rounded bg-[#17324D] text-white px-3 py-2 text-sm" disabled={busy}>Create invitation</button>
    </form>
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    {link && <div className="p-3 bg-[#EAF0F6] rounded space-y-2"><label className="block text-sm">Private setup link—share only with this employee<input aria-label="Invitation link" readOnly value={link} className="block w-full border rounded p-2 mt-1" onFocus={e => e.target.select()} /></label><button className="text-sm underline" onClick={() => navigator.clipboard.writeText(link).catch(() => setError("Select and copy the link above."))}>Copy invitation link</button></div>}
    <ul className="divide-y">{members.map(m => <li key={m.id} className="py-3 flex flex-wrap gap-3 items-center justify-between">
      <div><b className="text-sm">{m.name}</b><div className="text-xs text-stone-600">{m.email} · {!m.active ? "Access revoked" : m.pending ? "Awaiting setup" : "Active"}</div></div>
      <div className="flex gap-3 text-sm">
        {m.active && <button disabled={busy} className="underline" onClick={() => act(() => api.post(`/crm/team/${m.id}/invite`))}>New setup link</button>}
        <button disabled={busy} className="underline" onClick={() => {
          if (window.confirm(m.active ? `Revoke CRM access for ${m.name}?` : `Restore CRM access for ${m.name}?`)) act(() => api.patch(`/crm/team/${m.id}`, { active: !m.active }));
        }}>{m.active ? "Revoke access" : "Restore access"}</button>
      </div>
    </li>)}</ul>
  </section>;
}
